import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, DatePicker, Select } from 'antd';
import dayjs from 'dayjs';
import Button from "components/button";
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getPayrollDetails, doPayrollCreate, doPayrollUpdate 
} from "../../../../redux/payroll/payrollState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../utils/crudSagaHelper';
import { NumberFormatter } from "../../../../utils/index";
import Crudbuttons from "components/button/crudbuttons";
import { MODULE_PAYROLLS } from "variables/constants";

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

const PayrollForm = ({getRecord, doCreate, doUpdate, recordData, requesting, errors, onCancel, submitLabel, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	
  	useEffect(() => {
        getRecord(recordId ?? 0);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){
			/*const initialValues = {
				pay_id: recordData.pay_id,
				pay_account_id: recordData.pay_account_id,
			    pay_date_from: recordData.pay_date_from ? dayjs(recordData.pay_date_from, dateFormat) : null,
			    pay_date_to: recordData.pay_date_to ? dayjs(recordData.pay_date_to, dateFormat) : null,
			    pay_type_id: recordData.pay_type_id,
			    pay_status_id: recordData.pay_status_id,
			    pay_notes: recordData.pay_notes,
			    cut_off_date: [recordData.pay_date_from ? dayjs(recordData.pay_date_from, dateFormat) : null, recordData.pay_date_to ? dayjs(recordData.pay_date_to, dateFormat) : null]
			};	*/
			
			const { pay_date_from, pay_date_to, ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	            pay_date_from: pay_date_from ? dayjs(pay_date_from, dateFormat) : null,
			    pay_date_to: pay_date_to ? dayjs(pay_date_to, dateFormat) : null,
	            cut_off_date: [pay_date_from ? dayjs(pay_date_from, dateFormat) : null, pay_date_to ? dayjs(pay_date_to, dateFormat) : null]
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {  			
			const { cut_off_date, ...forSubmitValues } = values;			  
			forSubmitValues.pay_date_from = cut_off_date[0].format('YYYY-MM-DD');
			forSubmitValues.pay_date_to = cut_off_date[1].format('YYYY-MM-DD');									
			recordData.pay_id > 0 ? doUpdate(forSubmitValues): doCreate(forSubmitValues); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="pay_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
			    <FormItem
			        name="pay_account_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>			    
        		<div className="grid grid-cols-1 md:grid-cols-3">    
        			<FormItem className="font-medium mb-2"
		            	name="cut_off_date"
		                label="Cut-off Date"
		                rules={[requiredField()]}
		                validateStatus={(errors?.pay_date_from || errors?.pay_date_to) ? 'error' : ''}
                        help={(errors?.pay_date_from || errors?.pay_date_to) ? 'Payroll cut-off date already exist.' : ''}
		            >
		            	{mode === 'edit' ?
		            	<RangePicker className="font-normal"
		            		format={dateFormat}
		            		style={{
						        width: 250,
						      }}
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.pay_date_from} to {recordData?.pay_date_to}</label>
		            	}	                
	            	</FormItem>
		            <FormItem className="font-medium mb-2"
		            	name="pay_type_id"
		                label="Type"
		            >
		            	{mode === 'edit' ?
		            	<Select id="pay_type_id"
		            		style={{
						        width: 150,
						      }}
		            		options={recordData?.typeList}
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.pay_type_name}</label>
		                }
	            	</FormItem>
		            	<FormItem className="font-medium mb-2"
		            	name="pay_status_id"
		                label="Status"
		            >
		            	{mode === 'edit' ?
		            	<Select id="pay_status_id"
		            		style={{
						        width: 150,
						      }}
						      options={recordData?.statusList}
		            	/>		            		
		                : <label className="ps-3 dark:text-white">{recordData?.pay_status_name}{recordData?.pay_lastest_validation !== '' && ` (${recordData?.pay_lastest_validation})`}</label>
		                }
	            	</FormItem>
	            	<FormItem className="font-medium  mb-2 col-span-2"
		            	name="pay_notes"
		                label="Notes"
		                initialValue={recordData?.pay_notes}
		            >
		            	{mode === 'edit' ?
		            	<TextArea className="py-2"
		            		rows={2}
		            		
		            	/>
		                : <label className="ps-3 dark:text-white">{recordData?.pay_notes}</label>
		                }
	            	</FormItem>
	 			</div>				
	 			{mode === 'edit' ?
	 			<Crudbuttons
					mode={mode}
					recordId={recordData?.pay_id ?? 0}
					isModal={true}
					modalId={recordData?.pay_id > 0 ? 'edit_payroll' : 'add_payroll'}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					updateLabel="Update"
					submitLabel={submitLabel}
					moduleId={MODULE_PAYROLLS}
				/>            
	            : recordData?.payrunStatistics ? (
					<div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8">					
						{Object.entries(recordData?.payrunStatistics)?.map(([key, value]) => (
						<FormItem
							key={key}
							className="font-medium mb-2"
							name={key}
							label={key}
						>
							<label className="ps-3 dark:text-white">{key === 'FTE Total Net Pay' ? NumberFormatter(value) : value }</label>
						</FormItem>
						))}
					</div>
					) : ''
	            }
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.payroll.payrollDetails?.data,
  	requesting: state.payroll.payrollDetails?.requesting,
  	errors: state.payroll.payrollDetails?.errors,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getPayrollDetails(id)),
  	doCreate: (data) => dispatch(doPayrollCreate(data)),
  	doUpdate: (data) => dispatch(doPayrollUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollForm);
